export default "__VITE_ASSET__yKRVqmQx__"